// Validation function
export const validation = (req, res) => {
	const userAgent = req.headers['user-agent'];
	const allowedUserAgents = [
	  'Mozilla', 'Chrome', 'Safari', 'Firefox', 'Edge', 'OPR',
	  'SamsungBrowser', 'CriOS', 'FxiOS', 'EdgA', 'EdgiOS',
	  'Android', 'Mobile', 'iPhone', 'iPad', 'Tablet',
	  'Windows NT', 'Macintosh', 'Linux'
	];

	// Block requests without a valid User-Agent or with one that is likely not from a browser
	if (!userAgent || !allowedUserAgents.some(ua => userAgent.includes(ua))) {
	  res.status(403).json({ message: 'Forbidden: Invalid User-Agent' });
	  return false; // Validation failed
	}

	return true; // Validation passed
};